import { Container, styled } from '@mui/material';

export const StyledLayoutOutletContainer = styled(Container)(({ theme }) => ({
  marginTop: '2rem',
  maxWidth: 'xl',
}));